import React from 'react';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Features from '../components/Features';
import Blog from '../components/Blog';
import CTASection from '../components/CTASection';

function HomePage() {
  return (
    <>
      <SEO
        title="QASHQ Business & IT Consultants | Smarter Decisions. Stronger Business."
        description="Business and IT consulting solutions designed to help businesses operate smarter, grow faster, and build for the future. Accounting, advisory, and technology services."
        path="/"
      />
      <main>
        <article>
          <Hero />
          <About />
          <Services />
          <Features />
          <CTASection
            eyebrow="Have a business or technology challenge?"
            title="Let's Talk About Your Next Move."
            text="Schedule a free consultation with our team and explore how QASHQ can support your next stage of growth."
            secondaryLabel="Explore Our Services"
            secondaryTo="/services"
          />
          <Blog />
        </article>
      </main>
    </>
  );
}

export default HomePage;
